import { apiCall } from '../../context/api';

export const fetchUserProfile = async (token, base_url, setUser, setCompany) => {
  if (!token) return null;

  const data = await apiCall(base_url, token, 'GET', '/core/users/get-profile');
  setUser(data.user);
  setCompany(data.company);
};
